import { Outlet, Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { MapPin, Phone, Mail } from "lucide-react";

export const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col font-sans">
      {/* Top Bar */}
      <div className="bg-primary text-primary-foreground py-2 px-4 text-sm hidden md:block">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex gap-6">
            <span className="flex items-center gap-2"><MapPin size={16} /> Serving Local Homeowners</span>
            <span className="flex items-center gap-2"><Mail size={16} /> offers@rpyourhousebuyer.com</span>
          </div>
          <div className="flex items-center gap-2 font-semibold">
            <Phone size={16} /> Call Us 24/7: (321) 496-7719
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <header className="border-b bg-background sticky top-0 z-50">
        <div className="container mx-auto px-4 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="https://vibe.filesafe.space/1777468004016356373/attachments/9552e8e7-170d-4178-ba89-f09cb6c7c686.png" alt="Royal Properties Logo" className="w-10 h-10 rounded-md" />
            <div className="text-2xl font-bold text-primary flex flex-col leading-tight">
              <span>ROYAL PROPERTIES</span>
              <span className="text-xs text-muted-foreground tracking-widest uppercase">LLC Land Trust</span>
            </div>
          </Link>

          <NavigationMenu className="hidden lg:flex">
            <NavigationMenuList className="gap-2">
              <NavigationMenuItem>
                <NavigationMenuLink asChild className="group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50">
                  <Link to="/">Home</Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild className="group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50">
                  <Link to="/how-it-works">How It Works</Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild className="group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50">
                  <Link to="/about">About Us</Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild className="group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50">
                  <Link to="/areas-we-serve">Areas We Serve</Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild className="group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50">
                  <Link to="/situations">Situations</Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild className="group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50">
                  <Link to="/reviews">Reviews</Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild className="group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50">
                  <Link to="/blog">Blog</Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild className="group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50">
                  <Link to="/faq">FAQ</Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>

          <div className="flex items-center gap-4">
            <Button asChild variant="secondary" className="hidden sm:inline-flex font-bold">
              <Link to="/sell-your-house">Get Cash Offer</Link>
            </Button>
            {/* Mobile menu button would go here */}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-primary text-primary-foreground pt-16 pb-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <img src="https://vibe.filesafe.space/1777468004016356373/attachments/9552e8e7-170d-4178-ba89-f09cb6c7c686.png" alt="Royal Properties Logo" className="w-12 h-12 rounded-md" />
                <div className="text-2xl font-bold text-white flex flex-col leading-tight">
                  <span>ROYAL PROPERTIES</span>
                  <span className="text-xs text-primary-foreground/70 tracking-widest uppercase">LLC Land Trust</span>
                </div>
              </div>
              <p className="text-primary-foreground/80 mb-6">
                Professional home-buying company purchasing houses for cash since 2012. We buy houses as-is, with no fees or commissions.
              </p>
              <div className="flex items-center gap-2 font-bold text-accent mb-3">
                <Phone size={20} /> (321) 496-7719
              </div>
              <div className="flex items-start gap-2 text-primary-foreground/80">
                <MapPin size={20} className="shrink-0 mt-0.5 text-accent" />
                <span>255 S. Orange Ave STE. 104<br/>Orlando, FL 32801</span>
              </div>
            </div>
            
            <div>
              <h3 className="font-bold text-lg mb-4 text-white">Quick Links</h3>
              <ul className="space-y-2 text-primary-foreground/80">
                <li><Link to="/how-it-works" className="hover:text-accent transition-colors">How It Works</Link></li>
                <li><Link to="/about" className="hover:text-accent transition-colors">About Us</Link></li>
                <li><Link to="/reviews" className="hover:text-accent transition-colors">Testimonials</Link></li>
                <li><Link to="/situations" className="hover:text-accent transition-colors">Situations We Help</Link></li>
                <li><Link to="/blog" className="hover:text-accent transition-colors">Blog & Seller Guides</Link></li>
                <li><Link to="/faq" className="hover:text-accent transition-colors">FAQ</Link></li>
                <li><Link to="/contact" className="hover:text-accent transition-colors">Contact Us</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-lg mb-4 text-white">Areas We Serve</h3>
              <ul className="space-y-2 text-primary-foreground/80">
                <li><Link to="/areas-we-serve" className="hover:text-accent transition-colors">Atlanta, GA</Link></li>
                <li><Link to="/areas-we-serve" className="hover:text-accent transition-colors">Charlotte, NC</Link></li>
                <li><Link to="/areas-we-serve" className="hover:text-accent transition-colors">Orlando, FL</Link></li>
                <li><Link to="/areas-we-serve" className="hover:text-accent transition-colors">Dallas, TX</Link></li>
                <li><Link to="/areas-we-serve" className="hover:text-accent transition-colors">View All Areas</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-lg mb-4 text-white">Legal</h3>
              <ul className="space-y-2 text-primary-foreground/80">
                <li><Link to="/privacy" className="hover:text-accent transition-colors">Privacy Policy</Link></li>
                <li><Link to="/terms" className="hover:text-accent transition-colors">Terms of Service</Link></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-primary-foreground/20 pt-8 text-center text-primary-foreground/60 text-sm pb-24 md:pb-0">
            <p>&copy; {new Date().getFullYear()} Royal Properties LLC Land Trust. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Mobile Floating Action Button */}
      <div className="fixed bottom-6 left-4 right-4 z-50 md:hidden">
        <Button asChild className="w-full bg-accent text-primary hover:bg-accent/90 font-bold shadow-[0_10px_40px_rgba(0,0,0,0.3)] h-14 text-lg rounded-full border border-primary/10">
          <Link to="/sell-your-house" onClick={() => window.scrollTo(0, 0)}>Get Cash Offer</Link>
        </Button>
      </div>
    </div>
  );
};